import React from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";

const ErrorLayout = React.lazy(() => import("./layouts/Error/ErrorRoutes"));
const Page403 = React.lazy(() => import("./pages/Error/403"));
const Page404 = React.lazy(() => import("./pages/Error/404"));

const MainLayout = React.lazy(() => import("./layouts/Main/MainRoutes"));
const MainPage = React.lazy(() => import("./pages/Main/MainPage__index"));

const ContactLayout = React.lazy(() => import("./layouts/Contact/ContactRoutes"));
const ContactPage = React.lazy(() => import("./pages/Contact/Contact"));

const InformationPage = React.lazy(() => import("./pages/Information/Information"));

const DeclarationPage = React.lazy(() => import("./pages/Declaration/Declaration"));

const ShareLayout = React.lazy(() => import("./layouts/Share/ShareRoutes"));
const SharePage = React.lazy(() => import("./pages/Share/SharePage__index"));

const SearchLayout = React.lazy(() => import("./layouts/Search/SearchRoutes"));
const SearchPage = React.lazy(() => import("./pages/Search/SearchPage__index"));

export default function Routes() {
    return (
        <Router>
            <Switch>
                <MainLayout exact path="/" component={MainPage} />
                <ErrorLayout exact path="/error" component={Page404} />
                <ErrorLayout exact path="/wrong-id" component={Page404} isWrongId={'is-Wrong-Id'} />
                <ErrorLayout exact path="/denied" component={Page403} />
                <SearchLayout exact path="/search" component={SearchPage} />
                <ShareLayout exact path="/view/:terrID/:year/:indicatorID/:component" component={SharePage} />
                <ShareLayout
                    exact
                    path="/:voivodship/view/:terrID/:year/:indicatorID/:component"
                    component={SharePage}
                />
                <ContactLayout exact path="/Info" component={InformationPage} />
                <ContactLayout exact path="/Kontakt" component={ContactPage} />
                <ContactLayout exact path="/statement" component={DeclarationPage} />
                {/* <MainLayout exact path="/:voivodship" component={MainPage} /> */}
                <MainLayout exact path="/:terrID" component={MainPage} />
                <MainLayout exact path="/:terrID/:areaID" component={MainPage} />
                <MainLayout exact path="/:terrID/:areaID/:indicatorID" component={MainPage} />
                <ErrorLayout path="/*" component={() => <Redirect to="/error" />} />
            </Switch>
        </Router>
    );
}
